var Model = require("../types/Model.js");
var Promise = require("promise");
var util = require("util");
var window = require("global");

module.exports = Model({
	name: "contentupdate",
	init: init,
	triggers: triggers,
	listeners: listeners,

	checkForUpdate: checkForUpdate,
	doUpdate: doUpdate,
	downloadFrom: downloadFrom,
	prepareforUpdate: prepareforUpdate,

	_hasChecked: false,
	_apkVersion: null,
	_updating: false,
});

function init() {
	if(!shouldEnable()) return;
	this._hasChecked = false;
	this.push({
		versionData: {},
		updateState: "none"
	});
}

function listeners() {
	return {
		"machinetracker:updated": handle_machinetracker_update,
		"screenlocker:unlocked": doUpdate
	};
}

function triggers() {
	return {
		"update": prepareforUpdate //  unlock the screen, this allows the install dialogue 'pop up'
	};
}

/*  Functions to check if update is required */

function checkForUpdate() {
	return this.api
		.version
		.latest("atouchaway", "android")
		.then(doCheck.bind(this))
		.catch(console.error.bind(console));
}

function doCheck(newData) {
	var newVersion = newData.version;
	var currentVersion = this._apkVersion;
	this._hasChecked = true;

	if (newVersion === currentVersion)
		return this.extend({
			updateState: "current"
		});

	// No version change
	this.extend({
		updateState: "available",
		versionData: newData
	});
}

function handle_machinetracker_update(data) {
	if(!shouldEnable()) return;
	if (this._hasChecked) return;
	this._apkVersion = data.apk;

	this.checkForUpdate();
}

/* Functions for download and update */

function doUpdate() {
	if(!shouldEnable()) return;
	if (!this._updating) return;
	var data = this.data.versionData;
	var downloadURL = data.url;
	var apkFileName = downloadURL.split("/").pop(); //take filename from URL
	console.debug("Updating", apkFileName, downloadURL);
	return this.downloadFrom(downloadURL, apkFileName)
		.then(openAPK.bind(this))
		.then(successUpdate.bind(this))
		.catch(errorUpdate.bind(this));
}

function successUpdate() {
	this.extend({
		updateState: "complete"
	});
}

function prepareforUpdate() {
	this._updating = true;
	this.emit("screenlocker:trigger:unlock");
}

function errorUpdate(e) {
	console.error("Couldn't update,", e);
	this.extend({
		updateState: "error",
		errorMessage: util.inspect(e, {
			depth: null
		})
	});
}

function downloadFrom(url, file) {
	if (!window.cordova) return Promise.reject(new Error("Not in Cordova"));

	var toLocation = window.cordova.file.externalRootDirectory + "Download/" + file;
	var transfer = new window.FileTransfer();
	console.debug("Downloading file", url, toLocation);

	this.extend({
		updateState: "downloading"
	});

	return new Promise(function (resolve, reject) {
		transfer.download(url, toLocation, resolve, reject, false, {});
	});
}

function openAPK(apk) {
	if (!window.cordova) return Promise.reject(new Error("Not in Cordova"));

	this.extend({
		updateState: "installing"
	});

	return new Promise(function (resolve, reject) {
		console.debug("Opening APK", apk);
		var show = apk.toURL();
		window.plugins.APKOpener.open(show, resolve, reject);
	});
}

function shouldEnable() {
	return window.plugins && window.plugins.APKOpener;
}
